module.exports = __webpack_public_path__ + "img/picz_logo_white_mobile.d670a62e.svg";